import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {finalize, Observable, Subscription} from 'rxjs';
import {SitePublicService} from 'src/app/services/site-public.service';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {SpinnerService} from 'src/app/shared/waiting/spinner.service';
import {CarouselDialogComponent} from '../../dialogs/carousel-dialog/carousel-dialog.component';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {AngularFireUploadTask} from '@angular/fire/compat/storage';
import {FileManagerService} from 'src/app/shared/file-manager/file-manager.service';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: [ './carousel.component.scss' ]
})
export class CarouselComponent implements OnInit, OnDestroy {

  public dataSource: MatTableDataSource<any>
  //public displayedColumns: string[] = [ 'icon', 'file', 'dateIn', 'dateOut', 'edit', 'delete' ];
  public displayedColumns: string[] = [ 'icon', 'location', 'position', 'imageBig', 'imageSmall', 'dateIn', 'dateOut', 'link', 'edit', 'delete' ];

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  private statuteSubscription: Subscription | undefined;

  uploadTask: AngularFireUploadTask | undefined;
  uploadProgress: Observable<number | undefined> | undefined;
  downloadURL: string | null = null;
  isUploading = false;
  uploadError: string | null = null;

  public locations: any[] = []
  public selectedLocation: any;

  constructor (
    private _sitePublicService: SitePublicService,
    private _dialog: MatDialog,
    private _spinnerService: SpinnerService,
    private _snackBar: SnackBarIconService,
    private _fileManagerService: FileManagerService) {

    /*
    if (!this._authService.isAdmin) {
    this.router.navigate([ 'home' ]);
    }
    */
    this.locations = this._sitePublicService.loadLocations();
  }

  ngOnInit () { }

  ngOnDestroy () {
    if (this.statuteSubscription) {
      this.statuteSubscription.unsubscribe();
    }
  }

  applyFilter (filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  loadLocations () {
    this.locations.push("Site");
    this.locations.push("Congresso52");
    this.locations.push("Congresso53");
    this.locations.push("Programa52");
    this.locations.push("Programa53");
    this.locations.push('Convidados52');
    this.locations.push('Convidados53');
  }

  selectLocation (location) {
    console.log(location)
    this.selectedLocation = location;
    this.loadCarousel(this.selectedLocation)
  }

  loadCarousel (location) {

    const waiting = this._spinnerService.show();

    // 1. Chama o serviço que retorna o Observable
    const statute$ = this._sitePublicService.loadCarousel(location);

    console.log(statute$)

    // 2. Se inscreve no Observable
    this.statuteSubscription = statute$.subscribe({
      next: (array: any[]) => {
        // Este código será executado na primeira vez E em cada mudança subsequente.
        console.log('array: ' + JSON.stringify(array))

        this.dataSource = new MatTableDataSource(array);
        this.dataSource.sort = this.sort;
        // O 'waiting.close()' deve ser feito apenas na primeira vez.
        // Uma forma simples é verificar se o spinner está aberto ou usar 'finalize' no pipe.
        // Aqui, vamos apenas fechar, assumindo que já está aberto.
        if (waiting) {
          waiting.close();
        }
      },
      error: (error) => {
        console.error('Erro ao carregar o estatuto:', error);
        if (waiting) {
          waiting.close();
        }
        // Trate o erro (ex: exibir mensagem para o usuário)
      },
      // O complete não é chamado, pois é um Observable "infinito" (tempo real)
    });
  }

  openDialog (entity: any) {

    let data: any = {};
    if (entity) {
      data = entity;
    } else {
      data = {'id': "0", 'srcBig': '', 'fileBig': '', 'srcSmall': '', 'fileSmall': '', 'link': '', 'dateIn': null, 'dateOut': null};
    }

    let dialogRef = this._dialog.open(CarouselDialogComponent, {
      width: window.innerWidth.toString() + "px",
      height: window.innerHeight.toString() + "px",
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed()
      .subscribe(async (response) => {
        if (!response) {
          return;
        }

        const actionType: string = response[ 0 ];
        const form: any = response[ 1 ];
        const selectedFileBig: any = response[ 2 ];
        const selectedFileSmall: any = response[ 3 ];
        const formData = form.getRawValue();

        /*
        console.log("actionType: " + actionType)
        console.log("formData: " + JSON.stringify(formData))
        console.log("selectedFileBig: " + selectedFileBig.name)
        console.log("selectedFileSmall: " + selectedFileSmall.name)
        */

        if (actionType == 'insert') {

          delete formData.id;

          await this._sitePublicService.insertCarousel(formData)
            .then(async (result) => {
              if (selectedFileBig) {
                this.startUpload(result.id, formData.location, selectedFileBig, true);
              }

              if (selectedFileSmall) {
                this.startUpload(result.id, formData.location, selectedFileSmall, false);
              }

              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            })
            .catch((err: any) => {
              console.log("erro ao adicionar imagem")
              this._snackBar.openSnackBar("Erro!", '', 'error')
            });
        } else if (actionType == 'update') {

          const id = formData.id;
          const data = formData

          console.log(JSON.stringify(data))

          await this._sitePublicService.updateCarousel(id, data)
            .then(async () => {

              if (selectedFileBig) {
                if (data.srcBig) {
                  this._sitePublicService.deleteFileInStorage(data.srcBig)
                }
                this.startUpload(data.id, formData.location, selectedFileBig, true);
              }

              if (selectedFileSmall) {
                if (data.srcSmall) {
                  this._sitePublicService.deleteFileInStorage(data.srcSmall)
                }
                this.startUpload(data.id, formData.location, selectedFileSmall, false);
              }

              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            })
            .catch((err: any) => {
              console.log("erro ao atualizar imagem")
              this._snackBar.openSnackBar("Erro!", '', 'error')
            });
        }


      })

  }

  delete (element) {
    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.location + " - " + element.position + "<br><br>Excluir esta imagem?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        const id = element.id;
        const srcBig = element.srcBig;
        const srcSmall = element.srcSmall;

        if (srcBig) {
          this._sitePublicService.deleteFileInStorage(srcBig)
        }

        if (srcSmall) {
          this._sitePublicService.deleteFileInStorage(srcSmall)
        }

        this._sitePublicService.deleteCarousel(id)
          .then(
            () => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete carousel error: " + error.message)}
          )
      }
    })
  }

  startUpload (id: string, location: string, selectedFile: any, isBig: boolean): void {

    const waiting = this._spinnerService.show();

    this._fileManagerService.storage_path = "site_pub/carousel/" + location;

    this.isUploading = true;
    this.uploadError = null;
    this.downloadURL = null;

    const {task, downloadURL$} = this._fileManagerService.uploadFile(selectedFile);

    this.uploadTask = task;

    // Acompanhar o progresso
    this.uploadProgress = this.uploadTask.percentageChanges();

    // Obter o URL de download e finalizar
    downloadURL$.pipe(
      finalize(() => {
        this.isUploading = false;
        this.uploadTask = undefined;
      })
    ).subscribe({
      next: (url) => {
        if (url) {
          this.downloadURL = url;

          let dataToUpdate = {};
          if (isBig) {
            dataToUpdate = {srcBig: url};
          } else {
            dataToUpdate = {srcSmall: url};
          }
          this._sitePublicService.updateCarousel(id, dataToUpdate)
            .then(() => {
              console.log("upload image success")
            })
            .catch((err) => {
              console.log("erro upload image")
            })
            .finally(() => {
              waiting.close();
            })

        }
      },
      error: (err) => {
        this.uploadError = 'Erro no upload: ' + (err.message || 'Desconhecido');
        console.error('Erro no upload:', err);
      }
    });
  }

}
